import Lottie from "lottie-web";

import Monitor from "./_monitor.es6";
import ScanLine from "./_scanLine.es6";
import SMonitor from "./_smonitor.es6";
import InitModal from "./_initmodal.es6";

import { gnav } from "../common/ui/functions/gnav.es6";

export default class Main {
    constructor() {
        this.monitor = new Monitor();
        this.scanline = new ScanLine();
        this._init();
    }

    _init() {
        this._setupGlitchElmClone();
        this.scanline.setup();

        gnav();

        setTimeout(() => {
            this._setupLottie();
        }, 2000);

        setTimeout(() => {
            this.monitor.setup();
            this._setupSMonitors();
        }, 2500);

        // アニメーションが終わったらモーダル表示
        setTimeout(() => {
            const initmodal = new InitModal();
        }, 3000);
    }

    /**
     * グリッチ用の要素をcloneしてDOMに追加
     */
    _setupGlitchElmClone() {
        document.querySelectorAll(".c-glitch").forEach((elm) => {
            const targetElm = elm.querySelector(".c-glitch__target");
            if (!targetElm) return;

            const cloneElm = targetElm.cloneNode(true);
            elm.appendChild(cloneElm);
        });
    }

    _setupLottie() {
        const targetElm = document.querySelector(".js-lottie");

        const lottie = Lottie.loadAnimation({
            container: targetElm,
            renderer: "svg",
            loop: false,
            autoplay: true,
            path: targetElm.getAttribute("src"),
        });
        lottie.addEventListener("complete", () => {});
    }

    _setupSMonitors() {
        document.querySelectorAll(".js-smonitor").forEach((smonitorElm) => {
            const smonitor = new SMonitor(smonitorElm);
        });
    }
}
